import "reflect-metadata"; //It must be the first import of all of them in the prject, and the only file in the project that imports it.
import "@presentation/index.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "@presentation/App";
import { ContainerProvider } from "@presentation/components/dependencyInjection";
import { DIContainer } from "@utils/inversifyJS/inversify.config";
import { loadRuntimeConfig } from "@utils/runtimeConfig/runtimeConfig";

await loadRuntimeConfig();
// import reportWebVitals from './reportWebVitals';
const container = DIContainer;

ReactDOM.createRoot(document.querySelector("#root")!).render(
  <React.StrictMode>
    <ContainerProvider container={container}>
      <App />
    </ContainerProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
